import { DropdownItemModel } from '../pages/SingleUnit';

const removeTargetDuplicates = (items: DropdownItemModel[]): DropdownItemModel[] => {
  const seen = new Set<string>();
  return items.filter(({ label, value }) => {
    const key = `${label}-${value}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export default removeTargetDuplicates;
